//@flow

// Vendors
import React from 'react';
import { useDispatch } from 'react-redux';

// Components
import { Modal } from '../../../../modals';
import Trans from '../../../../Trans/Trans';
import { TxButton, TxButtonMode } from 'texkit-ui';

// Actions
import { closeModal } from '../../../../../../reducers/modal/modalActions';

// Styles
import './dps-packet-pending-modal.scss';

const DpsPacketPendingModal = () => {
  const dispatch = useDispatch();
  return (
    <Modal name="DpsPacketPendingModal" className="pending-packet-modal">
        <h2 className="h1 modal-title-general">
          <Trans file="dps" id="Packet_Pending" />
        </h2>
        <p className="modal-description-general">
          <Trans file="dps" id="Packet_Pending_Description" />
        </p>

      <TxButton
        className="modal-close-button"
        mode={TxButtonMode.Primary}
        onClick={() => dispatch(closeModal('DpsPacketPendingModal'))}
      >
        <Trans file="Labels" id="okGotIt" fallback="OK, got it" />
      </TxButton>
    </Modal>
  );
};

export default DpsPacketPendingModal;
